import Request from './request';

async function tree(data) {
  return Request('get', "api/material-categories/tree", data);
}

async function materialTree(data) {
  return Request('get', "api/material-categories/material-tree", data);
}

async function getCategories() {
  return Request('get', "api/material-categories/get-categories",);
}

export default {
  tree,
  materialTree,
  getCategories,
}